import { __awaiter } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useCallback, useEffect } from 'react';
import { isMobile } from '@dynamic-labs/multi-wallet';
import { FooterAnimationContextProvider } from './context/FooterAnimationContext/index.js';
import '@dynamic-labs/sdk-api';
import './shared/logger.js';
import { getFromLS } from './shared/utils/functions/storage/getFromLS.js';
import '@dynamic-labs/iconic';
import { useViewContext } from './context/ViewContext/ViewContext.js';
import { NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY } from './utils/constants/localStorage.js';
import './utils/constants/colors.js';
import { usePreventPageScroll } from './shared/utils/hooks/usePreventPageScroll/usePreventPageScroll.js';
import { authModalZIndex } from './shared/consts/index.js';
import { useInternalDynamicContext } from './context/DynamicContext/useInternalDynamicContext.js';
import { isSameWalletName } from './utils/functions/isSameWalletName/isSameWalletName.js';
import './components/ShadowDOM/ShadowDOM.js';
import './context/ThemeContext/ThemeContext.js';
import { Portal } from './components/Portal/Portal.js';
import 'react-dom';
import './config/ApiEndpoint.js';
import './context/ErrorContext/ErrorContext.js';
import 'ethers';
import { useWalletItemActions } from './utils/hooks/useWalletItemActions/useWalletItemActions.js';
import './utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import './components/IconButton/IconButton.js';
import { DynamicAuthLayout } from './layout/DynamicAuthLayout/DynamicAuthLayout.js';
import { useVerifyOnAwaitingSignature } from './utils/hooks/multiWallet/useVerifyOnAwaitingSignature/useVerifyOnAwaitingSignature.js';
import { isSelectedWalletAlreadyConnected } from './utils/functions/isSelectedWalletAlreadyConnected/isSelectedWalletAlreadyConnected.js';
import { viewToComponentMap } from './views/viewToComponentMap.js';
import './main.global.js';

const Main = () => {
    const { selectedWalletConnector, appName, connectedWallets, isProjectSettingsLoading, projectSettings, privacyPolicyUrl, setShowAuthFlow, showAuthFlow, termsOfServiceUrl, newToWeb3WalletChainMap, wallets, clearStatesOnBackClick, user, loginWithEmail, } = useInternalDynamicContext();
    const { view, setView } = useViewContext();
    usePreventPageScroll(showAuthFlow);
    const handleClose = () => {
        setShowAuthFlow(false);
        clearStatesOnBackClick();
    };
    const handleOnPortalUnmount = useCallback(
    // IMPORTANT: we need to reset the view because we reset state that the view depends on
    // so if the previous view renders when the user reopens the widget, it will crash
    () => {
        setView(loginWithEmail ? 'login-with-email-or-wallet' : 'wallet-list');
    }, [setView, loginWithEmail]);
    useVerifyOnAwaitingSignature();
    const { handleAlreadyConnectedWallet, handleCustodialWalletClick, handleInstalledExtensionClick, handleMobileWalletClick, handleUninstalledClick, } = useWalletItemActions();
    /* istanbul ignore next */
    const handleNewToWeb3WalletIntent = (walletConnector) => __awaiter(void 0, void 0, void 0, function* () {
        setShowAuthFlow(true);
        if (isSelectedWalletAlreadyConnected(connectedWallets, walletConnector, user)) {
            // wallet is already connected
            handleAlreadyConnectedWallet(walletConnector);
        }
        else if (walletConnector.canConnectViaCustodialService) {
            // providers like blocto and dapper
            handleCustodialWalletClick(walletConnector);
        }
        else if (isMobile()) {
            // mobile wallets
            handleMobileWalletClick(walletConnector);
        }
        else if (walletConnector.isInstalledOnBrowser()) {
            // browser extensions or injected wallets
            handleInstalledExtensionClick(walletConnector);
        }
        else {
            // wallet requiring a qr code (wallet connect/coinbase wallet)
            handleUninstalledClick(walletConnector);
        }
    });
    useEffect(() => {
        const newToWeb3WalletName = getFromLS(NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY);
        if ((wallets === null || wallets === void 0 ? void 0 : wallets.length) && newToWeb3WalletName) {
            const wallet = wallets.find((wallet) => isSameWalletName(wallet.name, newToWeb3WalletName));
            if (wallet === null || wallet === void 0 ? void 0 : wallet.walletConnector) {
                handleNewToWeb3WalletIntent(wallet.walletConnector);
            }
            localStorage.removeItem(NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY);
        }
    }, [wallets]);
    const showDynamicAuth = showAuthFlow && !isProjectSettingsLoading;
    return (jsx(FooterAnimationContextProvider, { children: jsx(Portal, Object.assign({ zIndex: authModalZIndex, isShown: showDynamicAuth, handleClose: handleClose, withBackdrop: true, transitionEvents: {
                onUnmount: handleOnPortalUnmount,
            } }, { children: jsx(DynamicAuthLayout, Object.assign({ transitionProps: { isShown: showDynamicAuth }, appName: appName, onClose: handleClose, walletName: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name, projectSettings: projectSettings, newToWeb3WalletChainMap: newToWeb3WalletChainMap, walletConnector: selectedWalletConnector, privacyPolicyUrl: privacyPolicyUrl, termsOfServiceUrl: termsOfServiceUrl }, { children: viewToComponentMap[view] })) })) }));
};

export { Main, Main as default };
